// @flow
import React from 'react'

// components
import { FieldLabel } from '../../Components/'

// types
import type { ArrayFieldFormType } from '../Types/ArrayFieldFormType'

type NumberInputArrayTypeProps = {
  arrayTypes: ArrayFieldFormType,
  debug: boolean,
  fieldName: string,
  label: string,
  onChange: (string, string, number) => void,
  prefix: string,
  value: number,
}

type NumberInputArrayTypeState = {
  value: string,
  valueFromProps: boolean,
}

export default class NumberInputArrayType extends React.Component<NumberInputArrayTypeProps, NumberInputArrayTypeState> {
  static getDerivedStateFromProps(nextProps: NumberInputArrayTypeProps, prevState: NumberInputArrayTypeState) {
    if (nextProps.value !== parseInt(prevState.value, 10) && prevState.valueFromProps) {
      return {
        valueFromProps: true,
        value: nextProps.value
      }
    }
    return null
  }

  state = {
    valueFromProps: true,
    value: ''
  }

  handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({ value: event.target.value, valueFromProps: false })
  }

  handleOnBlur = () => {
    const { arrayTypes, onChange, prefix, fieldName } = this.props

    if (this.state.value === '') {
      return true
    }

    const parsedValue = parseInt(this.state.value, 10)
    if (arrayTypes.minLength && (parsedValue < arrayTypes.minLength)) {
      onChange(fieldName, prefix, arrayTypes.minLength)
      return true
    } else if (arrayTypes.maxLength && (parsedValue > arrayTypes.maxLength)) {
      onChange(fieldName, prefix, arrayTypes.maxLength)
      return true
    } else {
      onChange(fieldName, prefix, parsedValue)
    }
  }

  render() {
    const { arrayTypes, label, debug, prefix, fieldName } = this.props
    let additionalProps = {}
    if (arrayTypes.minLength) {
      additionalProps['min'] = arrayTypes.minLength
    }
    if (arrayTypes.maxLength) {
      additionalProps['max'] = arrayTypes.maxLength
    }
    return (
      <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center'>
        <div className='col-10 col-sm-3 order-0 order-sm-0 text-sm-right'>
          <FieldLabel
            id={`array-type-name-${prefix}${fieldName}`}
            label={label}
          />
          {debug &&
          <p className='text-secondary'>
            {prefix.replace('-', '.')}{`${fieldName}ArrayCount`}
          </p>}
        </div>
        <div className='col-12 col-sm-5 order-3 order-sm-0 offset-sm-1 mt-sm-0 pr-sm-0'>
          <input
            className='form-control'
            data-hj-whitelist
            id={`array-type-name-${prefix}${fieldName}`}
            name={`array-type-name-${prefix}${fieldName}`}
            onBlur={this.handleOnBlur}
            onChange={this.handleOnChange}
            type='number'
            value={this.state.value || ''}
            {...additionalProps}
          />
        </div>
      </div>
    )
  }
}
